@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.container {
  @include border-radius-r2;
  display: flex;
  padding: 12px 16px;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
  border: 1px solid var(--border-soft);
  background: var(--surface-default);

  &.isButton {
    scroll-margin: var(--chat-footer-height);
    cursor: pointer;
    outline: none;

    &:hover {
      border-color: var(--border-hover);
    }

    &:focus-visible {
      border-color: var(--border-focus);
    }
  }
}

.messageContainer {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 4px;
}

.title {
  color: var(--text-soft);
  @include typography-v2-body-xs;
  text-align: left;
}

.message {
  display: flex;
  align-items: center;
  gap: 8px;
  @include typography-v2-body-sm;
  color: var(--text-default);
  text-align: left;

  button {
    padding: 4px 8px;
    color: var(--text-soft);
    border: 1px dashed var(--border-default);
  }
}

.iconContainer {
  padding: 4px;
  background: var(--background-soft);
  @include border-radius-r1;
  display: flex;

  svg {
    fill: var(--icon-disabled);
  }
}
